// Assuming you create this file for your CSS styles

export function WebSecurityYt(props) {

    const videoLinks = [
        { title: "1. UnityYT College", url: "https://www.youtube.com/watch?v=ESnrn1kAD4E&ab_channel=ApnaCollege" },
        { title: "2. SuperSimpleDev ( Highly Recommended )", url: "https://www.youtube.com/watch?v=G3e-cpL7ofc&t=1062s&ab_channel=SuperSimpleDev" },
        { title: "3. PW Skills Tech", url: "https://www.youtube.com/watch?v=WuiB5TAQOAM&ab_channel=PWSkillsTech" },
        { title: "4. SuperSimpleDev", url: "https://www.youtube.com/watch?v=OXGznpKZ_sA&ab_channel=freeCodeCamp.org" },
        { title: "5. Bro Code", url: "https://www.youtube.com/watch?v=HGTJBPNC-Gw&ab_channel=BroCode" },
        { title: "6. FreeCodeCamp", url: "https://www.youtube.com/watch?v=1Rs2ND1ryYc&ab_channel=freeCodeCamp.org" },
        { title: "7. Thapa Technical (Recommended)", url: "https://www.youtube.com/watch?v=MSICFljRcb4&t=23300s&ab_channel=ThapaTechnical" },
        { title: "8. Anuj Bhaiya ( TailWind CSS )", url: "https://www.youtube.com/watch?v=mGN9-FPsX9o&t=1043s&ab_channel=AnujBhaiya" },
        { title: "9. Apna College ( Recommended )", url: "https://www.youtube.com/watch?v=nGhKIC_7Mkk&ab_channel=ApnaCollege" },
        { title: "10. Ws Cube Tech (TailWind CSS)", url: "https://www.youtube.com/watch?v=Sae1MD5E5p8&ab_channel=WsCubeTech" }
    ];

    return (
        <>
            <h1 className="html_yt_heading">
                These are the <strong style={{ textDecoration: 'underline', color: 'blue' }}>Top 10</strong> YouTube Playlists That You can Refer
            </h1>

            <h4 className="des_yt_html">
                1. Dive Into The Main Concepts <br />
                2. Animation Explanations with real-world Examples <br />
                3. Important with Note Clarification.
            </h4>

            <ul className="video-list">
                {videoLinks.map((video, index) => (
                    <li key={index} className="video-item">
                        <p className="vid">{video.title}</p>
                        <button
                            className="video-btn"
                            onClick={() => window.open(video.url, "_blank")}
                        >
                            Click Me
                        </button>
                    </li>
                ))}
            </ul>
        </>
    );
}

export default WebSecurityYt;
